// extracted by mini-css-extract-plugin
export var chip = "_4x-0";
export var filterDropdown = "_4x-5";
export var filterItem = "_4x-6";
export var icon = "_4x-1";
export var removeButton = "_4x-3";
export var removeIcon = "_4x-4";
export var separator = "_4x-2";